var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccessGlobal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#BAF4E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1357 23.6358V29.0735H14.8677V23.6358C14.8677 23.3954 14.9654 23.1649 15.1394 22.9949C15.3134 22.825 15.5494 22.7295 15.7955 22.7295H36.2079C36.454 22.7295 36.69 22.825 36.864 22.9949C37.038 23.1649 37.1357 23.3954 37.1357 23.6358Z",
    fill: "#44AB96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1357 30.886V36.3237C37.1357 36.5641 37.038 36.7946 36.864 36.9645C36.69 37.1345 36.454 37.23 36.2079 37.23H15.7955C15.5494 37.23 15.3134 37.1345 15.1394 36.9645C14.9654 36.7946 14.8677 36.5641 14.8677 36.3237V30.886H37.1357Z",
    fill: "#44AB96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5938 22.7273H44.6166C44.8386 22.7273 45.0516 22.7926 45.2086 22.9089C45.3656 23.0252 45.4538 23.1829 45.4538 23.3474V36.9894C45.4538 37.1538 45.3656 37.3115 45.2086 37.4278C45.0516 37.5441 44.8386 37.6095 44.6166 37.6095H39.5938V22.7273Z",
    fill: "#44AB96"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessGlobal);
export default __webpack_public_path__ + "static/media/accessGlobal.f18a6d41eb93cce5ea78afe813c75429.svg";
export { ForwardRef as ReactComponent };